import { Component } from '@angular/core';
import { ToastController, LoadingController,ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Usuario } from '../../entities/usuario';
import { Empresa } from '../../entities/empresa';
import { UsuarioDAO } from '../../daos/usuario-dao';

@Component({
    selector: 'page-usuario-novo',
    templateUrl: 'usuario-novo.html'
})
export class UsuarioNovoPage {
    public formInscricao: FormGroup;
    public usuario: Usuario = new Usuario();

    public Empresas: Empresa[] = [
        new Empresa().deserialize({ Id: 1, Descricao: 'Dilady Lingerie' }),
        new Empresa().deserialize({ Id: 2, Descricao: 'Love Secret Lingerie' }),
        new Empresa().deserialize({ Id: 4, Descricao: 'Finna Lingerie' })
    ];

    constructor(
        _formBuilder: FormBuilder,
        private _viewCtrl: ViewController,
        private _toastCtrl: ToastController,
        private _loadingCtrl: LoadingController,
        private _usuarioDao: UsuarioDAO
    ) {
        this.formInscricao = _formBuilder.group({
            NomeCompleto: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            Perfil: ['', Validators.compose([Validators.required])],
            Empresa: ['', Validators.compose([Validators.required])],
            Usuario: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            Senha: ['', Validators.compose([Validators.required, Validators.minLength(4)])]
        });
    }

    public doSignup(): void {
        this.usuario.NomeUsuario = this.usuario.NomeUsuario.toLowerCase();
        this.usuario.Senha = this.usuario.Senha.toLowerCase();
        this.usuario.Ativo = "1";

        if (this.formInscricao.invalid) {
            this._toastCtrl.create({
                message: 'O formulário está invalido. Favor Verifique!',
                duration: 3000
            }).present();

            return;
        }

        let load = this._loadingCtrl.create({ content: 'Autenticando o usuário...' });
        load.present();

        this.usuario.Empresa = this.Empresas.find(a => a.Id == this.formInscricao.controls['Empresa'].value);

        this._usuarioDao.signup(this.usuario).then(() => {
            load.dismiss().then(() => {
                this._toastCtrl.create({
                message: 'Cadastro realizado com sucesso!',
                duration: 3000
                }).present().then(() => {
                this._viewCtrl.dismiss(true);                  
                });
            });
            //this._navCtrl.pop().then(() => {
            //    load.dismiss();
            //});
        }).catch((erro) => {
            console.error(erro);
            load.dismiss();
            this._toastCtrl.create({
                message: 'Não foi possível cadastrar usuário, tente novamente!',
                duration: 3000
            }).present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/usuario-novo/usuario-novo.ts